export default __webpack_public_path__ + "static/media/ActivationPending.84cdd24f.svg";